import {HomePage} from "./HomePage";
import {SearchPage} from "./SearchPage";
import {FavoritesPage} from "./FavoritesPage";

export {
  HomePage,
  SearchPage,
  FavoritesPage,
};
